import { toast } from "react-toastify";
import { apiSlice } from "../api/apiSlice";

export const accountApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTrailBalance: builder.query({
      query: () => ({
        url: `account?query=tb`,
      }),
      providesTags: ["getTrailBalance"],
    }),

    getBalanceSheet: builder.query({
      query: () => ({
        url: `account?query=bs`,
      }),
      providesTags: ["getBalanceSheet"],
    }),

    getIncomeStatement: builder.query({
      query: () => ({
        url: `account?query=is`,
      }),
      providesTags: ["getIncomeStatement"],
    }),

    getMainAccount: builder.query({
      query: () => ({
        url: `account?query=ma`,
      }),
      providesTags: ["getMainAccount"],
    }),

    getSubAccount: builder.query({
      query: (id) => ({
        url: `account/${id}`,
      }),
      providesTags: ["getSubAccount"],
    }),

    getAccounts: builder.query({
      query: () => ({
        url: `account?query=sa`,
      }),
      providesTags: ["getAccounts"],
    }),

    getAccount: builder.query({
      query: (id) => ({
        url: `account/${id}`,
      }),
      providesTags: ["getAccount"],
    }),

    addAccount: builder.mutation({
      query: (values) => ({
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `account/`,
        body: values,
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toast.success("Account added successfully");
        } catch (err) {
          toast.error("An error occurred while adding Account");
        }
      },
      invalidatesTags: ["getMainAccount", "getSubAccount", "getAccounts"]
    }),

    updateAccount: builder.mutation({
      query: ({ id, values }) => ({
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `account/${id}`,
        body: values,
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toast.success("account updated successfully");
        } catch (err) {
          toast.error("An error occurred while updating account");
        }
      },
      invalidatesTags: ["getMainAccount", "getSubAccount", "getAccounts"],
    }),

    deleteAccount: builder.mutation({
      query: (id) => ({
        url: `account/${id}`,
        method: "DELETE",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        body: {
          status: false,
        },
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toast.success("Deleted Account successful");
        } catch (err) {
          toast.error("An error occurred while deleting the Account");
        }
      },
      invalidatesTags: ["getMainAccount", "getSubAccount", "getAccounts"],
    }),
  }),
});

export const {
  useGetTrailBalanceQuery,
  useGetBalanceSheetQuery,
  useGetIncomeStatementQuery,
  useGetMainAccountQuery,
  useGetSubAccountQuery,
  useGetAccountsQuery,
  useGetAccountQuery,
  useAddAccountMutation,
  useUpdateAccountMutation,
  useDeleteAccountMutation,
} = accountApi;
